module.exports = __webpack_public_path__ + "img/4-2.738ee753.png";